import React, { memo, useEffect, useRef, useState } from 'react'
import styled from '@emotion/styled'
import { dancingBarsNumber } from '../../assets/constants'
import { ControlBtn, Divider } from '../'
import { Play, Stop, SpeakerOn, SpeakerOff, Copy, CopyDone, ArrowUp, ArrowDown } from '../../assets/icons'
import { useGlobalContext } from '../../context'
import { useClipboard, useLocalStorage } from '../../hook'
import Slider from './Slider'
import { AXIOS } from '../../utils/axios'
import axios from 'axios'

export default function MusicPlayer() {
  const { activeGenre, isPlaying, setIsPlaying } = useGlobalContext()

  const [isMute, setIsMute] = useLocalStorage('isMute', false)
  const [volume, setVolume] = useLocalStorage('volume', 0.25)
  const [lastVolume, setLastVolume] = useLocalStorage('lastVolume', 0.25)
  const [initialMusic, setInitialMusic] = useState({})
  const { isCopied, copyToClipboard } = useClipboard()
  const [url, setUrl] = useState(activeGenre.server_url ?? initialMusic.server_url)
  const [isReduceUsage, setIsReduceUsage] = useState(false)

  const getInitialMusic = () => {
    axios
      .all([AXIOS.get(`/blues/img`, { responseType: 'blob' }), AXIOS.get('/genre/all')])
      .then(
        axios.spread((imgRes, dataRes) => {
          setInitialMusic({
            img: URL.createObjectURL(imgRes.data),
            ...dataRes.data.data[1],
          })
        })
      )
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    getInitialMusic()
    //when reload we must pause 1-UX 2-is'nt playing the song cause abort!
    setIsPlaying(false)
    //eslint-disable-next-line
  }, [])

  // set Volume to the audio
  const audio = useRef(null)
  useEffect(() => {
    if (audio.current) {
      audio.current.volume = volume
    }
  }, [volume])

  //For abort ! for every time after first one
  useEffect(() => {
    if (isPlaying) {
      setUrl(activeGenre.server_url ?? initialMusic.server_url)
    } else {
      setUrl('')
    }
    //eslint-disable-next-line
  }, [isPlaying, activeGenre])

  //For abort ! in the first time
  useEffect(() => {
    if (isPlaying) {
      setUrl(activeGenre.server_url ?? initialMusic.server_url)
    } else {
      setUrl('')
    }
    //eslint-disable-next-line
  }, [])

  // explicit play() (instead of the autoPlay attribute) so rejected play promises don't go uncaught
  useEffect(() => {
    if (url && audio.current) {
      audio.current.play().catch(() => {})
    }
  }, [url])

  //# toggle mute: remember volume to restore it on unmute
  const toggleMute = () => {
    if (isMute) {
      setIsMute(false)
      setVolume(lastVolume || 0.25)
    } else {
      setLastVolume(volume)
      setIsMute(true)
      setVolume(0)
    }
  }

  const volumeHandler = (number) => {
    const newVolume = number / 100
    setVolume(newVolume)
    setIsMute(newVolume === 0)
  }

  //# For Each time we have change in genre set the volume to new one because each time we create new audio
  useEffect(() => {
    if (audio?.current) {
      audio.current.volume = volume
    }
    //eslint-disable-next-line
  }, [activeGenre, isPlaying])
  return (
    <Wrapper className='flex-column gap-2'>
      <img
        src={activeGenre.img ?? initialMusic.img}
        alt={activeGenre?.title ?? initialMusic?.title ?? 'کاور آهنگ در حال پخش'}
      />
      <h3>{activeGenre?.title?.split('-')[1] ?? initialMusic?.title?.split('-')[1]}</h3>
      <h4>{activeGenre?.title?.split('-')[0] ?? initialMusic?.title?.split('-')[0]}</h4>

      <audio
        ref={audio}
        src={url}
      />

      <Divider text={activeGenre.genre || initialMusic.genre} />
      <div className='flex-between'>
        <ControlBtn
          onIcon={<Copy />}
          offIcon={<CopyDone />}
          active={isCopied}
          onChange={() => copyToClipboard(activeGenre.server_url ?? initialMusic.server_url)}
        />
        <ControlBtn
          onIcon={<Play />}
          offIcon={<Stop />}
          active={isPlaying}
          onChange={() => setIsPlaying((prev) => !prev)}
        />

        <ControlBtn
          onIcon={<ArrowUp />}
          offIcon={<ArrowDown />}
          active={isReduceUsage}
          onChange={() => setIsReduceUsage((prev) => !prev)}
        />
      </div>
      <div className='flex-between gap-2'>
        <ControlBtn
          onIcon={<SpeakerOn />}
          offIcon={<SpeakerOff />}
          active={isMute}
          onChange={toggleMute}
        />
        <Slider
          volume={volume * 100}
          onChange={volumeHandler}
        />{' '}
        <span className='number'>{Math.ceil(volume * 100)}%</span>
      </div>
      <PlayingBars
        active={isPlaying}
        mute={isMute}
      />
    </Wrapper>
  )
}

const Wrapper = styled('div')(() => ({
  position: 'relative',
  background: 'var(--black-player-500)',
  padding: '1rem',
  borderRadius: 'var(--radius)',
  width: '300px',
  margin: '2rem auto',
  // placeSelf:'stretch',
  h3: {
    color: 'var(--text-50)',
    textAlign: 'center',
    fontFamily: 'var(--primary-bold)',
    fontSize: '1.2rem',
  },
  h4: {
    color: 'var(--text-100)',
    textAlign: 'center',
    fontSize: '1rem',
  },
  img: {
    borderRadius: 'var(--radius)',
    width: '100%',
    minHeight: '250px',
    background: 'var(--black-player-900)',
    objectFit: 'cover',
  },
  '.number': {
    width: '68px',
    textAlign: 'center',
    color: 'var(--text-white)',
  },
}))

const PlayingBars = memo(function PlayingBars({ active, mute }) {
  const styles = { active }
  const barStyle = { mute }
  return (
    <PlayBarsWrapper styles={styles}>
      {Array(dancingBarsNumber)
        .fill(Math.random())
        .map((item, index) => {
          return (
            <Bar
              barStyle={barStyle}
              key={index}
              height={Math.random() * item}
              delay={Math.random()}
              className={active ? '' : 'stop'}
            />
          )
        })}
    </PlayBarsWrapper>
  )
})

const PlayBarsWrapper = styled('div')(({ styles: { active } }) => ({
  width: '100%',

  height: active ? '75px' : '0',
  marginTop: active ? '2.25rem' : '-1rem',
  display: 'flex',
  justifyContent: 'start',
  alignItems: ' flex-end',
  gap: '1px',
  transition: '.5s all',
  '.stop': {
    animation: ' up-to-down .5s ease 1 alternate',
    height: '0',
  },
  '@keyframes up-and-down ': {
    '10%': {
      height: '30%',
    },
    '30%': {
      height: '100%',
    },
    '60%': {
      height: '50%',
    },
    '80%': {
      height: '75%',
    },
    '100% ': {
      height: '60%',
    },
  },
  '@keyframes up-to-down ': {
    '0%': {
      height: '60%',
    },
    '50%': {
      height: '90%',
    },
    '100% ': {
      height: '0%',
    },
  },
}))

const Bar = styled('span')(({ barStyle: { mute }, height, delay }) => ({
  width: '30%',
  height: `${height}%`,
  animation: ' up-and-down 1.3s ease infinite alternate',
  animationDelay: `${delay}s`,
  transition: 'background .3s',
  ':nth-of-type(7n + 1) ': {
    background: mute ? 'var(--text-600)' : '#ff0000',
  },
  ':nth-of-type(7n + 2) ': {
    background: mute ? 'var(--text-600)' : '#ff8000',
  },
  ':nth-of-type(7n + 3) ': {
    background: mute ? 'var(--text-600)' : '#ffff00',
  },
  ':nth-of-type(7n + 4) ': {
    background: mute ? 'var(--text-600)' : '#00ff00',
  },
  ':nth-of-type(7n + 5) ': {
    background: mute ? 'var(--text-600)' : '#0000ff',
  },
  ':nth-of-type(7n + 6) ': {
    background: mute ? 'var(--text-600)' : '#8000ff',
  },
  ':nth-of-type(7n + 7) ': {
    background: mute ? 'var(--text-600)' : '#ff00ff',
  },
}))
